export const loadNewRelicPixel = async () => {
    const options = {
        init: {privacy:{cookies_enabled:true}}, // NREUM.init
        info: {beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"f6ac81556f",applicationID:"47286850",sa:1}, // NREUM.info
        loader_config: {accountID:"1583867",trustKey:"1583867",agentID:"47286913",licenseKey:"f6ac81556f",applicationID:"47286850"} // NREUM.loader_config
    }

    const {BrowserAgent} = await import('@newrelic/browser-agent/loaders/browser-agent');
    new BrowserAgent(options);
}